export { default as dissolveShader } from './fragment/dissolve.frag?raw';
export { default as maskShader } from './fragment/mask.frag?raw';
export { default as wipeShader } from './fragment/wipe.frag?raw';